import { Autocomplete, TextField } from "@mui/material";
import {
  getInputLabelProps,
  getInputProps,
  getAutocompleteInputProps,
  PopperFullWidth,
} from "../../common/appStyles";
import { useEffect, useState } from "react";

export default function Combobox({
  id,
  handleValueChange,
  fieldValue,
  fieldOptions,
  fieldLabel,
  popperFullWidth,
  customOptionLabel,
  disabled,
  optionFilter,
  isRequired,
  dotUseFullWidth,
  onkeyUp,
  customSx,
}) {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (fieldValue == null) {
      setInputValue("");
    } else {
      setInputValue(
        customOptionLabel
          ? customOptionLabel(fieldValue)
          : fieldValue?.Name ?? "",
      );
    }
  }, [fieldValue]);

  return (
    <Autocomplete
      sx={customSx}
      inputlabelprops={getInputLabelProps()}
      inputprops={getInputProps()}
      size="small"
      fullWidth={!dotUseFullWidth}
      onChange={(_e, value) => {
        handleValueChange(value);

        if (value == null) {
          setInputValue("");
        }
      }}
      onInputChange={(_event, newInputValue, reason) => {
        if (reason === "input" || reason === "clear") {
          setInputValue(newInputValue);
        }
      }}
      inputValue={inputValue}
      id={id}
      value={fieldValue}
      disabled={disabled}
      options={fieldOptions}
      getOptionLabel={customOptionLabel ?? ((option) => option?.Name ?? "")}
      isOptionEqualToValue={
        optionFilter ?? ((option, value) => option?.Id === value?.Id)
      }
      PopperComponent={popperFullWidth ?? PopperFullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          required={isRequired}
          InputProps={getAutocompleteInputProps(params.InputProps)}
          size="small"
          InputLabelProps={getInputLabelProps()}
          label={fieldLabel}
          onKeyDown={onkeyUp}
        />
      )}
    />
  );
}
